import { render, staticRenderFns } from "./TablesSidebarItem.vue?vue&type=template&id=9612645a&scoped=true"
import script from "./TablesSidebarItem.vue?vue&type=script&lang=js"
export * from "./TablesSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./TablesSidebarItem.vue?vue&type=style&index=0&id=9612645a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9612645a",
  null
  
)

export default component.exports